import { LitElement, html, css } from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

const skioStyles = css`
  .hidden {
    display: none;
  }

  .skio-bab {
    --primary: black;
    --primary-hover: white;
    --font-primary: "xyngia", sans-serif;
    --font-secondary: Assistant, sans-serif;
  }

  .skio-bab {
    display: block;
    margin: auto;
    max-width: 1500px;
    padding: 0 30px 50px;
    color: #000;
    font-family: var(--font-primary) !important;
    z-index: 3;
    position: relative;
  }

  .skio-bab-sticky_atc {
    position: fixed;
    bottom: 0%;
    width: 100vw;
    background-color: white;
    border-top: 1px solid black;
  }

  .skio-bab__title {
    font-style: normal;
    font-weight: 800;
    font-size: 30px;
    line-height: 35px;
    margin: 0;
  }

  .skio-bab__subtitle {
    max-width: 740px;
    font-family: "ibm_plex_sanssemibold";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #767c82;
    text-transform: uppercase;
  }

  .skio-bab-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-areas: "products products products products cart cart cart";
    grid-auto-rows: max-content;
    align-items: flex-start;
    gap: 2rem;
  }

  .skio-bab-products {
    grid-area: products;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    grid-row-gap: 3rem;
    grid-column-gap: 2rem;
  }

  .skio-bab-products {
    transition: opacity 0.3s ease;
  }

  .skio-bab-products.fade-out {
    opacity: 0;
  }

  .skio-bab-products.fade-in {
    opacity: 1;
  }

  .skio-bab-cart {
    grid-area: cart;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 8rem;
  }

  .skio-bab-cart__title {
    text-align: center;
    margin: 1rem;
    font-family: var(--font-primary);
    font-size: 3rem;
  }

  .skio-bab-cart__description {
    margin: 0 0 10px 0;
    padding: 0 10px;
    text-align: center;
  }

  .skio-bab-product-card {
    text-align: center;
    line-height: 120%;
    color: #000;
  }

  .skio-bab-product-card__image img {
    display: block;
    max-width: 100%;
    height: auto;
    transition: transform 0.3s ease;
  }

  .skio-bab-product-card__image {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .skio-bab-product-card__image img:hover {
    transform: scale(1.05);
    cursor: pointer;
  }

  .skio-bab-product-card__titlegroup {
    min-height: 4lh;
  }

  .skio-bab-product-card__title {
    font-weight: 500;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 6px;
  }

  .skio-bab-product-card__subtitle {
    font-weight: 400;
    text-align: center;
    font-size: 14px;
    line-height: 12px;
    margin-bottom: 16px;
    font-style: italic;
  }

  .skio-bab-product-card__price {
    margin: 1rem 0;
  }

  .skio-bab-product-card__price s {
    margin: 0 0.5rem;
    font-weight: 400;
  }

  .skio-bab-product-card__atc {
    width: 30%;
    text-transform: uppercase;
  }
  .skio-bab-product-card__atc.added {
    background-color: #4CAF50; // or any color you prefer
    cursor: default;
  }

  .skio-bab-cart-item {
    display: flex;
    gap: 1rem;
    padding: 1rem 0.5rem;
    line-height: 120%;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  }

  .skio-bab-cart-item:last-of-type {
    border-bottom: none;
  }

  .skio-bab-cart-item__image {
    width: 120px;
  }

  .skio-bab-cart-item__image img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .skio-bab-cart-item__info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex-grow: 1;
  }

  .skio-bab-cart-item__title {
    font-weight: 600;
    font-size: 14px;
  }

  .skio-bab-cart__subtitle {
    text-align: center;
    font-weight: 400;
    padding: 2rem 0;
  }

  .skio-bab-cart-footer__description {
    color: #1b1b1b;
    margin-top: 20px;
    font-family: vollkorn;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
  }

  .skio-bab-cart-item__total {
    margin-top: auto;
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .skio-bab-cart-item__remove {
    display: inline-flex;
    background: none;
    margin-left: auto;
    cursor: pointer;
    // border: 1px solid var(--primary);
    border: none;
    padding: 0.5em;
    border-radius: 5px;
  }

  .skio-bab-cart__footer {
    margin-top: 2rem;
  }

  .skio-bab-cart__subscription {
    margin: 0 0 2rem;
  }

  .skio-bab-cart__subtotal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
  }

  .skio-bab-cart__info {
    margin: 0;
    font-size: 11px;
  }

  .skio-bab-cart__checkout {
    margin-top: 1rem;
    font-size: 16px;
    padding: 1.5rem 2rem;
    display: block;
    text-decoration: none;
    text-align: center;
    font-family: var(--font-primary) !important;
  }

  .skio-bab-plan-picker__label {
    font-weight: 600;
  }

  .skio-bab-plan-picker__select {
    border: none;
    padding: 1rem;
    width: 100%;
    max-width: 320px;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 5px;
  }

  .skio-bab-quantity-picker {
    display: flex;
    gap: 1.5rem;
    margin: auto;
    justify-content: center;
  }

  .skio-bab-quantity-picker__status {
    line-height: 175%;
  }

  .skio-bab-cart__visual {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
  }

  // .skio-bab-cart__visual-item {
  //   width: 50%;
  // }

  // .skio-bab-cart__visual-item img {
  //   width: 90%;
  // }

  button.skio-bab-quantity-picker__btn {
    width: 30px;
    height: 30px;
    padding: 0;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn {
    background-color: var(--primary);
    border: none;
    color: white;
    border-radius: 5px;
    font-weight: 700;
    cursor: pointer;
    transition: 200ms ease;
    padding: 0.7em 3em;
    width: auto;
    border: 1px solid black;
  }

  .btn:hover {
    background-color: var(--primary-hover);
    color: var(--primary);
  }

  .btn:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .skio-bab-box-size-selector {
  }

  .skio-bab-box-size-selector button {
    padding: 10px;
    border-radius: 7px;
    background: transparent;
    font-size: 20px;
    font-weight: 500;
    font-family: var(--font-primary) !important;
    display: inline-block;
    border: 1px solid #767c82;
    box-sizing: border-box;
    border-radius: 8px;
    overflow: hidden;
    margin-right: 15px;
    width: 50px;
    height: 50px;
    transition: 200ms ease;
  }

  .skio-bab-box-size-selector button.selected {
    background: black;
    color: white;
  }

  .skio-bab-box-size-selector button:hover {
    cursor: pointer;
  }

  .skio-bab-box-size-selector button:not(.selected):hover {
    background: white;
  }

  @media (max-width: 992px) {
    .skio-bab-grid {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  @media (max-width: 700px) {
    .skio-bab-products {
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    }

    .skio-bab-product-card__image img {
      height: 300px;
      max-width: 170%;
      width: auto;
    }

    .skio-bab-product-card__image {
    }
  }

  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    border: 0;
  }
  .skio-onetime-second {
    order: 2;
  }

  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    border-radius: 30px;
    border: 1px solid #767c82;
    border-radius: 8px;
    background-color: transparent;
  }
  .skio-group-container--selected {
  }

  .skio-group-container--selected::before {
    content: "";
    position: absolute;
    top: calc(var(--variant-pills-border-width) * -1);
    right: calc(var(--variant-pills-border-width) * -1);
    bottom: calc(var(--variant-pills-border-width) * -1);
    left: calc(var(--variant-pills-border-width) * -1);
    z-index: -1;
    border-radius: var(--variant-pills-radius);
    box-shadow: var(--variant-pills-shadow-horizontal-offset) var(--variant-pills-shadow-vertical-offset) var(--variant-pills-shadow-blur-radius)
      rgba(var(--color-shadow), var(--variant-pills-shadow-opacity));
  }

  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }

  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 10px;
    overflow: hidden;
    border-radius: 8px;
    transition: 200ms ease;
  }

  .skio-group-label:hover {
    background-color: white;
  }

  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
  }

  .skio-radio__container {
    display: flex;
    margin-right: 10px;
  }

  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }

  .skio-price {
    margin-left: auto;
  }

  .skio-group-content {
    width: auto;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 38px;
    opacity: 1;
  }

  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }

  .skio-group-title {
    min-width: max-content;
  }

  .skio-save {
    color: #0fa573;
    border: 1px #0fa573 solid;
    padding: 0px 8px;
    border-radius: 20px;
  }

  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    margin-top: 5px;
    border-radius: 5px;
    background-color: #f7f7f7;
    width: 75%;
    border: 1px solid black;
    font-size: 14px;
    font-family: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
    pointer-events: none;
  }

  .skio-frequency span {
    text-transform: lowercase;
  }
`;

export class SkioBuildABoxComponent extends LitElement {
  static styles = skioStyles;

  static properties = {
    products: { type: Array },
    cartItems: { type: Array },
    staticBoxes: { type: Array },
    selectedBox: { type: Object },
    selectedParentVariant: { type: Object },
    staticChildVariants: { type: Array },
    parentBoxVariantIds: { type: String },
    domain: { type: String },
    boxProduct: { type: Object },
    availableSellingPlanGroups: { type: Array },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },
    defaultFrequency: { type: String },
    boxHandle: { type: String },
    discountFormat: { type: String },
    checkoutButtonPrice: { type: Boolean },
    cartFooterDescription: { type: String },
    reviews: { type: Object },
    loading: { type: Boolean },
    screenSize: { type: Number },

    showUpsells: { type: Boolean },
    upsellProducts: { type: String },
  };

  constructor() {
    super();

    this.products = [];
    this.cartItems = [];
    this.staticBoxes = [];
    this.selectedBox = {};
    this.selectedParentVariant = {};
    this.staticChildVariants = [];
    this.parentBoxVariantIds = "";
    this.domain = "";
    this.boxProduct = {};
    this.availableSellingPlanGroups = [];
    this.selectedSellingPlanGroup = {};
    this.selectedSellingPlan = {};
    this.defaultFrequency = "";
    this.boxHandle = "";
    this.discountFormat = "percent";
    this.checkoutButtonPrice = false;
    this.cartFooterDescription = "";
    this.reviews = {};
    this.loading = true;
    this.screenSize = window.innerWidth;
    this.handleResize = this.handleResize.bind(this);
    this.shopifyVariants = [];
    this.startSubscription = true;
    this.showUpsells = false;
    this.upsellProducts = "";
    this.addedUpsells = new Set();
    this.upsellQuantities = new Map();
  }

  async connectedCallback() {
    super.connectedCallback();
    window.addEventListener("resize", this.handleResize);

    try {
      this.boxProduct = await this.getShopifyProduct(this.boxHandle);

      let boxVariantIds = this.parentBoxVariantIds.split(",");
      if (boxVariantIds.length > 1) {
        for (let id of boxVariantIds) {
          const box = await this.getStaticBox(id);
          this.staticBoxes.push(box);
        }
      }
      //TODO - add handling for a single box
      this.staticChildVariants = this.staticBoxes[0].selectableProductVariants;
      this.selectedBox = this.staticBoxes[0];

      const variantPromises = this.staticChildVariants.map(variant => this.getShopifyProduct(variant.productSlug));
      const products = await Promise.all(variantPromises);
      this.shopifyVariants = products.map(product => product.variants).flat();

      this.requestUpdate();
      
      const upsellHandles = this.upsellProducts.split(',');
      
      if (upsellHandles.length > 0) {
        try {
          const upsellPromises = upsellHandles.map(handle => 
            fetch(`/products/${handle.trim()}.js`)
              .then(response => response.json())
          );
          
          this.upsellProducts = await Promise.all(upsellPromises);
        } catch (error) {
          console.error('Error loading upsell products:', error);
          this.upsellProducts = []; // Fallback to empty array if loading fails
        }
      }
    } catch (error) {
      console.error("Error in connectedCallback:", error);
    } finally {
      this.loading = false;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", this.handleResize);
  }

  updated = (changed) => {
    if (changed.has("selectedBox") && this.selectedBox) {
      
      this.selectedParentVariant = this.boxProduct?.variants?.find(
        (variant) => variant.id == this.composeOrDecomposeGid(this.selectedBox.platformId)
      );
      
    }

    if (changed.has("boxProduct") && this.boxProduct) {
      this.availableSellingPlanGroups = this.boxProduct.selling_plan_groups?.filter((group) => group.app_id === "SKIO");
    }

    if (changed.has("selectedParentVariant") && this.selectedParentVariant) {
      console.log("updating based on selectedparentvariant update");

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.boxProduct.selling_plan_groups?.filter((group) => group.app_id === "SKIO");
      let skioSellingPlanGroups = JSON.parse(JSON.stringify(this.availableSellingPlanGroups));
      

      this.availableSellingPlanGroups = skioSellingPlanGroups.filter((selling_plan_group) =>
        selling_plan_group.selling_plans.some((selling_plan) =>
          this.selectedParentVariant?.selling_plan_allocations.some(
            (selling_plan_allocation) => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      );

      //update selectedSellingPlan value
      
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan

        console.log("updating aspg to disclude bad plans");

        this.availableSellingPlanGroups.forEach((group) => {
          group.selling_plans = group.selling_plans.filter((x) =>
            this.selectedParentVariant?.selling_plan_allocations.find((y) => y.selling_plan_id == x.id)
          );
        });

        this.availableSellingPlanGroups.forEach((group) => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find((x) => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        });

        if (this.startSubscription == true || this.boxProduct?.requires_selling_plan == true) {
          //find a matching selling plan, or choose first available

          if (this.selectedSellingPlan == null || this.selectedSellingPlan == undefined) {
            this.selectSellingPlanGroup(this.availableSellingPlanGroups[0]);
          }

          let sellingPlanName = this.selectedSellingPlan?.name;

          let sellingPlanGroup = this.availableSellingPlanGroups.find((x) => x.selling_plans.find((y) => y.name == sellingPlanName));
          let sellingPlan = sellingPlanGroup?.selling_plans.find((y) => y.name == sellingPlanName);
          if (sellingPlan && sellingPlanName === sellingPlan.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup;
            this.selectedSellingPlan = sellingPlan;
          } else {
            this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
            this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
          }
        } else {
          this.selectedSellingPlan, (this.selectedSellingPlanGroup = null);
        }
      } else {
        this.selectedSellingPlan, (this.selectedSellingPlanGroup = null);
      }
    }

    if (changed.has("cartItems")) {
      // console.log("cart:", this.cartItems);
    }
  };

  //SECTION - Utility Functions

  handleAddToCartClick() {
  if (!this.hasUpsells) {
    // If no upsells, go straight to checkout
      this.checkout();
    } else {
      // If there are upsells, show the upsell screen
      this.showUpsells = true;
    }
  }

  addToCart(variant, quantity = 1) {
    if (this.totalItems == this.selectedBox.size) return;
    this.cartItems = [
      ...this.cartItems,
      {
        quantity,
        variant,
      },
    ];
  }

  removeFromCart(productId) {
    this.cartItems = this.cartItems.filter(({ product }) => product.id !== productId);
  }

  clearCart() {
    this.cartItems = [];
  }

  setQuantity(variant, quantity, update) {
    if (this.totalItems == this.selectedBox.size && update == "adding") return;

    if (this.cartItems.find((cartItem) => variant.platformId === cartItem.variant.platformId && cartItem.quantity))
      this.cartItems = this.cartItems
        .map((lineItem) => {
          if (variant.platformId === lineItem.variant.platformId) {
            lineItem.quantity = quantity;
          }
          return lineItem;
        })
        .filter((lineItem) => lineItem.quantity !== 0);
  }

  composeOrDecomposeGid(id) {
    if (id.includes("gid")) return id.replace("gid://shopify/ProductVariant/", "");
    return "gid://shopify/ProductVariant/" + id;
  }

  handleResize() {
    this.screenSize = window.innerWidth;
    this.requestUpdate();
  }

  price(selling_plan, formatted = true) {
    return formatted
      ? money(this.selectedParentVariant?.price - getSubscriptionDiscount(selling_plan).amount)
      : this.selectedParentVariant?.price - getSubscriptionDiscount(selling_plan).amount;
  }

  get totalItems() {
    return this.cartItems.reduce((count, { quantity }) => {
      count += quantity;
      return count;
    }, 0);
  }

  get spreadCart() {
    const spreadCart = [];

    this.cartItems.forEach((item) => {
      if (item.quantity > 1) {
        for (let i = 0; i < item.quantity; i++) {
          spreadCart.push({ variant: item.variant, quantity: 1 });
        }
      } else {
        spreadCart.push(item);
      }
    });

    return spreadCart;
  }

  selectBoxBySize(size) {
    if (size < this.selectedBox.size) this.clearCart();
    if (size === this.selectedBox.size) return;
    this.selectedBox = this.staticBoxes.find((box) => box.size === size);
  }

  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
  }

  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find((x) => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    } else this.log("Error: couldn't find selling plan with id " + element.value);
  }

  //TODO - add option for direct to checkout
checkout() {

  // First add the main bundle
  let bundleData = {
    items: [{
      id: this.selectedParentVariant.id,
      quantity: 1,
      selling_plan: this.selectedSellingPlan ? this.selectedSellingPlan.id : "",
      properties: {}
    }]
  };

  this.cartItems.forEach((cartItem) => {
    bundleData.items[0].properties[`_pvgid://shopify/ProductVariant/${this.composeOrDecomposeGid(cartItem.variant.platformId)}`] = cartItem.quantity;
    bundleData.items[0].properties[`${cartItem.variant.productTitle}`] = cartItem.quantity;
  });

  // Add upsells to the items array
  Array.from(this.addedUpsells).forEach(productId => {
    const quantity = this.upsellQuantities.get(productId);
    const product = this.upsellProducts.find(p => p.id === productId);
    
    if (quantity > 0 && product && product.variants && product.variants[0]) {
      bundleData.items.push({
        id: product.variants[0].id,
        quantity: quantity
      });
    }
  });

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bundleData),
  })
  .then(response => response.json())
  .then(result => {
    
    // Fetch updated cart data
    return fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(cart => {
        
        // Trigger cart drawer update
        if (window.Shopify && window.Shopify.onCartUpdate) {
          window.Shopify.onCartUpdate(cart);
        }
        
        // Optional: redirect to cart page
        // window.location.href = `${window.Shopify.routes.root}cart`;
        window.upcartOpenCart()
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
        window.location.href = `${window.Shopify.routes.root}cart`;
      });
  })
  .catch((error) => {
    console.error("Error:", error);
    window.location.href = `${window.Shopify.routes.root}cart`;
  });
}

  getStaticBox(boxParentProductId) {
    return new Promise((resolve, reject) => {
      fetch("https://api.skio.com/storefront-http/get-classic-box-v2", {
        method: "POST",
        body: JSON.stringify({
          productVariantPlatformId: boxParentProductId,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.ok) throw new Error("Failed to get box");
          const { ClassicBoxV2 } = response;
          resolve(ClassicBoxV2);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  }

  getShopifyProduct(handle) {
    return new Promise((resolve, reject) => {
      fetch(`/products/${handle}.js`, {
        method: "GET",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to get product: ${response.statusText}`);
          }
          return response.json();
        })
        .then((product) => {
          resolve(product);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
          reject(error);
        });
    });
  }

  //SECTION - HTML templates

  loadingScreen() {
    return html`
      <div class="skio-loading ${this.loading ? "" : "loaded"}">
        <div class="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    `;
  }

  productCard(variant) {
    const cartItem = this.cartItems.find((cartItem) => variant.platformId === cartItem.variant.platformId);

    return html`
      <div class="skio-bab-product-card">
        <div
          @click="${(e) => (this.shopifyVariants.length > 0 && this.shopifyVariants?.find(v => v.id == this.composeOrDecomposeGid(variant.platformId)).available ? (cartItem ? this.setQuantity(variant, cartItem.quantity + 1, "adding") : this.addToCart(variant)) : null)}"
          class="skio-bab-product-card__image"
        >
          <img width height src=${variant.imageSrc + "&width=400"} alt=${variant.productTitle} />
        </div>
        <div class="skio-bab-product-card__titlegroup">
          <div class="skio-bab-product-card__title">${variant.productTitle.replace('- 12 Pack', '')}</div>
          <div class="skio-bab-product-card__subtitle hidden">${variant.productVariantTitle}</div>
        </div>
        <div class="skio-bab-product-card__actions">
          ${this.cartItems.some((cartItem) => variant.platformId === cartItem.variant.platformId)
            ? html`${this.quantityPicker(variant)}`
            : html`
                <button
                  class="skio-bab-product-card__atc btn"
                  @click="${(e) => this.addToCart(variant)}"
                  ?disabled=${this.totalItems == this.selectedBox.size || (this.shopifyVariants.length > 0 && !this.shopifyVariants.find(v => v.id == this.composeOrDecomposeGid(variant.platformId)).available)}
                >
                  ${this.shopifyVariants.length > 0 && this.shopifyVariants.find(v => v.id == this.composeOrDecomposeGid(variant.platformId)).available ? html`Add` : html`Sold Out`}
                </button>
              `}
        </div>
      </div>
    `;
  }

  upsellProductCard(product) {
    const isAdded = this.addedUpsells.has(product.id);
    const quantity = this.upsellQuantities.get(product.id) || 0;
    
    return html`
      <div class="skio-bab-product-card">
        <div class="skio-bab-product-card__image">
          <img width height src=${product.featured_image} alt=${product.title} />
        </div>
        <div class="skio-bab-product-card__titlegroup">
          <div class="skio-bab-product-card__title">${product.title}</div>
        </div>
        <div class="skio-bab-product-card__price">
          ${money(product.price)}
        </div>
        <div class="skio-bab-product-card__actions">
          ${isAdded 
            ? html`
              <div class="skio-bab-quantity-picker">
                <button 
                  class="skio-bab-quantity-picker__btn btn" 
                  @click=${() => {
                    const newQuantity = quantity - 1;
                    if (newQuantity === 0) {
                      this.addedUpsells.delete(product.id);
                      this.upsellQuantities.delete(product.id);
                    } else {
                      this.upsellQuantities.set(product.id, newQuantity);
                    }
                    this.requestUpdate();
                  }}
                >
                  -
                </button>
                <div class="skio-bab-quantity-picker__status">${quantity}</div>
                <button 
                  class="skio-bab-quantity-picker__btn btn" 
                  @click=${() => {
                    this.upsellQuantities.set(product.id, quantity + 1);
                    this.requestUpdate();
                  }}
                >
                  +
                </button>
              </div>
            `
            : html`
              <button
                class="skio-bab-product-card__atc btn"
                @click=${() => {
                  this.addedUpsells.add(product.id);
                  this.upsellQuantities.set(product.id, 1);
                  this.requestUpdate();
                }}
              >
                ADD
              </button>
            `
          }
        </div>
      </div>
    `;
  }

  // Standard cart layout
  cartBodyStandard(cartItems) {
    return html`
      <div class="skio-bab-cart__title"></div>
      <p class="skio-bab-cart__description"></p>
      <div class="skio-bab-cart__items-grid">
        ${!this.cartItems.length
          ? html`
              <h5 class="skio-bab-cart__subtitle">
                Your cart is empty.
                <h5></h5>
              </h5>
            `
          : null}
        ${this.cartItems.map(
          ({ variant, quantity }) => html`
            <div class="skio-bab-cart__item skio-bab-cart-item">
              <div class="skio-bab-cart-item__image">
                <img src=${variant.imageSrc} alt="" />
              </div>
              <div class="skio-bab-cart-item__info">
                <div class="skio-bab-cart-item__title">${variant.productTitle}</div>
                <div class="skio-bab-cart-item__total">
                  <button @click=${() => this.removeFromCart(product.id)} class="skio-bab-cart-item__remove">🗑️</button>
                </div>
              </div>
            </div>
          `
        )}
      </div>
    `;
  }

  cartBodyVisual() {
    
  }

  cartHeader() {
    return html`
      <h2 class="skio-bab__title">${this.selectedBox.title}</h2>
      <img style="width: 150px;" src="https://stamped.io/inc/image/stars.png?apikey=c743c961-093f-4b97-b49b-2c64e1e61e89&sId=290818&productId=7432242102455" />
    `;
  }

  boxSizeSelector() {
    return html`
      <div class="skio-bab-box-size-selector">
        <h4 class="skio-bab__subtitle">Pack Size</h4>
          ${this.staticBoxes.map(
            (box) =>
              html`
                <div tabindex="0" role="button" aria-label="box-size-${box.size}" @click="${() => this.selectBoxBySize(box.size)}" class="${this.selectedBox.size === box.size ? "selected" : ""}">
                  ${box.size}
                </div>
              `
          )}
      </div>
    `;
  }

  planPicker() {
    return html`
      <h4 class="skio-bab__subtitle">Frequency</h4>
      <fieldset class="skio-plan-picker">
        ${this.availableSellingPlanGroups
          ? this.availableSellingPlanGroups.map(
              (group, index) =>
                html`
                  <div
                    class="skio-group-container skio-group-container--available ${this.selectedSellingPlanGroup == group
                      ? "skio-group-container--selected"
                      : ""}"
                    skio-group-container
                    @click=${() => this.selectSellingPlanGroup(group)}
                  >
                    <input
                      id="skio-selling-plan-group-${index}"
                      class="skio-group-input"
                      name="skio-group"
                      type="radio"
                      value="${group.id}"
                      skio-selling-plan-group="${group.id}"
                      ?checked=${this.selectedSellingPlanGroup == group ? true : false}
                    />
                    <label class="skio-group-label" for="skio-selling-plan-group-${index}">
                      <div class="skio-group-topline">
                        <div class="skio-radio__container">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1"></circle>
                            <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                          </svg>
                        </div>
                        <div class="skio-group-title">
                          ${group.name == "Subscription" ? "Subscribe & Save" : group.name}
                          ${getSubscriptionDiscount(this.selectedParentVariant, group.selected_selling_plan).percent !== "0%"
                            ? html`
                                <span
                                  ><span skio-discount
                                    >${this.discountFormat == "percent"
                                      ? getSubscriptionDiscount(this.selectedParentVariant, group.selected_selling_plan).percent
                                      : getSubscriptionDiscount(this.selectedParentVariant, group.selected_selling_plan).amount}</span
                                  ></span
                                >
                              `
                            : html``}
                        </div>
                        <div class="skio-price ${this.checkoutButtonPrice ? "hidden" : ""}">
                          ${this.selectedParentVariant?.price <
                          this.selectedParentVariant?.price - getSubscriptionDiscount(this.selectedParentVariant, group.selected_selling_plan).amount
                            ? html` <del>${money(this.selectedParentVariant.price / 100)}<del> </del></del> `
                            : html``}
                          <span skio-subscription-price
                            >${money(
                              this.selectedParentVariant?.price -
                                getSubscriptionDiscount(this.selectedParentVariant, group.selected_selling_plan).amount
                            )}</span
                          >
                        </div>
                      </div>
                      <div class="skio-group-content">
                        <select
                          skio-selling-plans="${group.id}"
                          class="skio-frequency${group.selling_plans.length == 1 ? " skio-frequency--one" : ""}"
                          @change=${(e) => this.selectSellingPlan(e.target, group)}
                        >
                          ${group
                            ? group.selling_plans.map(
                                (selling_plan) =>
                                  html`
                                    <option value="${selling_plan.id}" ?selected=${group.selected_selling_plan == selling_plan}>
                                      ${group.name == "Subscription" ? `Delivery ${selling_plan.name.toLowerCase()}` : `${selling_plan.name}`}
                                    </option>
                                  `
                              )
                            : ""}
                        </select>
                      </div>
                    </label>
                  </div>
                `
            )
          : ""}
           <div
          class="skio-group-container ${this.boxProduct.requires_selling_plan == false ? "skio-group-container--available" : ""} ${this
            .selectedSellingPlanGroup == null
            ? "skio-group-container--selected"
            : ""} ${this.subscriptionFirst ? "skio-onetime-second" : ""}"
          skio-group-container
          @click=${() => this.selectSellingPlanGroup(null)}
        >
          <input
            id="skio-one-time"
            class="skio-group-input"
            name="skio-group"
            type="radio"
            value=""
            skio-one-time
            ?checked=${this.startSubscription == false && this.boxProduct.requires_selling_plan == false ? true : false}
          />
          <label class="skio-group-label" for="skio-one-time">
            <div class="skio-group-topline">
              <div class="skio-radio__container">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                </svg>
              </div>
              <div class="skio-group-title">One-time Purchase</div>
              <div class="skio-price ${this.checkoutButtonPrice ? "hidden" : ""}">
                <span skio-onetime-price>${money(this.selectedParentVariant?.price)}</span>
              </div>
            </div>
          </label>
        </div>
      </fieldset>
    `;
  }

  addToCartButton() {
    return html`
      ${this.totalItems < this.selectedBox.size 
        ? html`
          <button
            type="submit"
            class="skio-bab-cart__checkout btn button"
            disabled
          >
            ADD ${this.selectedBox.size - this.totalItems} MORE ${this.selectedBox.size - this.totalItems == 1 ? "OPTION" : "OPTIONS"}
          </button>
        `
        : html`
          <button
            type="submit"
            @click=${() => {
              if (this.showUpsells) {
                // If we're on the upsell screen, proceed to checkout
                this.checkout();
              } else if (!this.hasUpsells) {
                // If no upsells exist, go straight to checkout
                this.checkout();
              } else {
                // If upsells exist and we're not on upsell screen, show upsells
                const productsGrid = this.querySelector('.skio-bab-products');
                productsGrid.classList.add('fade-out');
                
                setTimeout(() => {
                  this.showUpsells = true;
                  this.requestUpdate();
                  
                  setTimeout(() => {
                    productsGrid.classList.remove('fade-out');
                    productsGrid.classList.add('fade-in');
                  }, 50);
                }, 300);
              }
            }}
            class="skio-bab-cart__checkout btn button"
          >
            ${this.showUpsells ? 'ADD BUNDLE TO CART' : (this.hasUpsells ? 'NEXT' : 'ADD TO CART')}
          </button>
        `
      }
      <p class="skio-bab-cart__info"></p>`;
  }

  get hasUpsells() {
    return this.upsellProducts && Array.isArray(this.upsellProducts) && this.upsellProducts.length > 0;
  }

  cartFooter() {
    return html`
      <div class="skio-bab-cart__footer">
        <p class="skio-bab-cart-footer__description">${this.cartFooterDescription}</p>
      </div>
    `;
  }

  quantityPicker(variant) {
    const cartItem = this.cartItems.find((cartItem) => variant.platformId === cartItem.variant.platformId);

    return html`
      <div class="skio-bab-quantity-picker">
        <button class="skio-bab-quantity-picker__btn btn" @click="${() => this.setQuantity(variant, cartItem.quantity - 1)}">-</button>
        <div class="skio-bab-quantity-picker__status">${cartItem.quantity}</div>

        <button
          class="skio-bab-quantity-picker__btn btn"
          @click="${() => this.setQuantity(variant, cartItem.quantity + 1, "adding")}"
          ?disabled=${this.totalItems == this.selectedBox.size}
        >
          +
        </button>
      </div>
    `;
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      ${this.loadingScreen()}
      ${this.screenSize < 993
        ? html`
            <div id="skio-build-a-box" class="skio-bab">
              <h2 class="skio-bab__title"></h2>
              <p class="skio-bab__description"></p>
              <h4 class="skio-bab__subtitle"></h4>
              <div class="skio-bab-grid">
                <div class="skio-bab-grid__cart skio-bab-cart">
                  ${this.cartHeader()} 
                  ${this.boxSizeSelector()} 
                  ${this.planPicker()}
                </div>
                <div class="skio-bab-grid__products skio-bab-products">
                  ${!this.showUpsells
                    ? this.staticChildVariants.map((variant) => this.productCard(variant))
                    : (Array.isArray(this.upsellProducts) && this.upsellProducts.length > 0 
                        ? this.upsellProducts.map(product => this.upsellProductCard(product))
                        : html`<p>No upsell products available</p>`)
                  }
                </div>
              </div>
              ${this.cartFooter()}
              <div class="skio-bab-sticky_atc">
                ${this.cartBodyVisual()}
                ${this.addToCartButton()}
              </div>
            </div>
          `
        : html` <div id="skio-build-a-box" class="skio-bab">
            <h2 class="skio-bab__title"></h2>
            <p class="skio-bab__description"></p>
            <h4 class="skio-bab__subtitle"></h4>
            <div class="skio-bab-grid">
             <div class="skio-bab-grid__products skio-bab-products">
                ${!this.showUpsells
                  ? this.staticChildVariants.map((variant) => this.productCard(variant))
                  : (Array.isArray(this.upsellProducts) && this.upsellProducts.length > 0 
                      ? this.upsellProducts.map(product => this.upsellProductCard(product))
                      : html`<p>No upsell products available</p>`)
                }
              </div>
              <div class="skio-bab-grid__cart skio-bab-cart">
                ${this.cartBodyVisual()} 
                ${this.cartHeader()} 
                ${this.boxSizeSelector()} 
                ${this.planPicker()} 
                ${this.addToCartButton()}
                ${this.cartFooter()}
              </div>
            </div>
          </div>`}
    `;
  }
}

customElements.define("skio-build-a-box", SkioBuildABoxComponent);

/* 
 Global money formatter
 */
const moneyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: window?.Shopify?.currency?.active || "USD",
});

/* 
 Formats integer value into money value
 */
const money = (price) => {
  return moneyFormatter.format(price / 100.0);
};

/*
 Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
 */
const getSubscriptionDiscount = (variant, selling_plan) => {
  if (!selling_plan) return { percent: "0%", amount: 0 };

  const price_adjustment = selling_plan.price_adjustments[0];
  const discount = { percent: "0%", amount: 0 };
  const price = variant.price;

  switch (price_adjustment.value_type) {
    case "percentage":
      discount.percent = `${price_adjustment.value}%`;
      discount.amount = Math.round((price * price_adjustment.value) / 100.0);
      break;
    case "fixed_amount":
      discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`;
      discount.amount = price_adjustment.value;
      break;
    case "price":
      discount.percent = `${Math.round((((price - price_adjustment.value) * 1.0) / price) * 100.0)}%`;
      discount.amount = price - price_adjustment.value;
      break;
  }

  return discount;
};
